/* Trigger styling moved to Interstate Tailwind utility classes in
   SupportMenuTrigger.ts's markup. Only the bits that can't be utilities remain here.
   The base/utilities + `.ids-*` components layers come from the shared
   ../../../styles/tailwind-{shared,components}.css imports in SupportMenuTrigger.ts
   (ARGUS PR #164 CRITICAL). */

:host {
  display: contents;
}

.trigger-wrapper > [class*="pendo-resource-center-badge-notification-bubble"] {
  top: -2px !important;
  left: auto !important;
  right: -10px !important;
  transform: scale(0.75) !important;
  transform-origin: top right !important;
}

/* Get Help button DARK mode — host-attribute driven (App.ts reflects `dark` from
   bb_theme="Interstate-Dark"), not a Tailwind `dark:` variant, so it overrides the
   light utility classes here. CAI dark secondary palette: text/border #75b8ee,
   interactive surface #113455, focus ring 2px #17191f + 4px #75b8ee. */
:host([dark]) .trigger-button {
  color: #75b8ee;
  border-color: #75b8ee;
  background-color: transparent;
}

:host([dark]) .trigger-button:hover,
:host([dark]) .trigger-button:active {
  color: #75b8ee;
  border-color: #75b8ee;
  background-color: #113455;
}

:host([dark]) .trigger-button:focus-visible {
  box-shadow: 0 0 0 2px #17191f, 0 0 0 4px #75b8ee;
}

/* US2003211 AC8/AC11: forced-colors suppresses box-shadows, so restore a keyboard
   focus outline (WCAG 2.4.7) via the system Highlight color. */
@media (forced-colors: active) {
  .trigger-button:focus-visible {
    outline: 2px solid Highlight;
    outline-offset: 2px;
  }
}

@media (max-width: 479px) {
  .trigger-label {
    display: none;
  }
}
